import React, { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import './TranscriptAnalysisLeftPanel.css';

const TranscriptAnalysisLeftPanel = ({ 
  availableOptions, 
  selectedOptions, 
  onOptionChange, 
  onGenerate 
}) => {
  const [inputMethod, setInputMethod] = useState('auto');

  const handleGenerate = () => {
    onGenerate();
  };

  return (
    <div className="transcript-left-panel">
      {/* Header */}
      <div className="panel-header">
        <h1 className="panel-title">Earnings Call Transcript Analysis</h1>
        <p className="panel-description">
          Analyze earnings call transcripts for actionable insights and management commentary.
        </p>
      </div>

      {/* Input Method Tabs */}
      <div className="input-method-tabs">
        <button 
          className={`tab ${inputMethod === 'auto' ? 'active' : ''}`}
          onClick={() => setInputMethod('auto')}
        >
          Auto
        </button>
        <button 
          className={`tab ${inputMethod === 'manual' ? 'active' : ''}`}
          onClick={() => setInputMethod('manual')}
        >
          Manual
        </button>
      </div>

      {/* Configuration Sections */}
      <div className="config-sections">
        {/* Bank Selection */}
        <div className="config-section">
          <div className="config-label">Bank</div>
          <div className="config-buttons">
            {availableOptions.banks?.map((bank) => (
              <button
                key={bank}
                className={`config-button ${selectedOptions.bank === bank ? 'active' : ''}`}
                onClick={() => onOptionChange('bank', bank)}
              >
                {bank}
              </button>
            ))}
          </div>
        </div>

        {/* Year Selection */}
        <div className="config-section">
          <div className="config-label">Year</div>
          <div className="config-buttons">
            {availableOptions.years?.map((year) => (
              <button
                key={year}
                className={`config-button ${selectedOptions.year === year ? 'active' : ''}`}
                onClick={() => onOptionChange('year', year)}
              >
                {year}
              </button>
            ))}
          </div>
        </div>

        {/* Quarter Selection */}
        <div className="config-section">
          <div className="config-label">Quarter</div>
          <div className="config-buttons">
            {availableOptions.quarters?.map((quarter) => (
              <button
                key={quarter}
                className={`config-button ${selectedOptions.quarter === quarter ? 'active' : ''}`}
                onClick={() => onOptionChange('quarter', quarter)}
              >
                {quarter}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Generate Button */}
      <button 
        className="generate-button"
        onClick={handleGenerate}
        disabled={!selectedOptions.bank || !selectedOptions.year || !selectedOptions.quarter}
      >
        <RefreshCw size={16} />
        Generate
      </button>
    </div>
  );
};

export default TranscriptAnalysisLeftPanel;

